/**
 * Preferencias → marca: comparar en vivo el sistema actual y la PROPUESTA
 * Aquila (PDF de Ana, 2026-09-01) sin tocar un componente — solo cambia la
 * clase de marca del tema (@skein/design). La decisión final va a
 * design/explorations/decision.md; esto es el instrumento para tomarla.
 */
import { useTheme } from "@skein/design";
import { Button, Help, Modal, Radio } from "@skein/ui";

export function BrandPicker({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { brand, setBrand, light, toggleLight } = useTheme();
  return (
    <Modal
      open={open}
      onClose={onClose}
      className="pos-dialog"
      title="Preferencias"
      subtitle="Marca del sistema — para comparar la propuesta con Ana. La decisión se escribe en el decision log."
      footer={<Button variant="ghost" onClick={onClose}>Cerrar</Button>}
    >
      <div style={{ display: "grid", gap: "var(--sk-sp-4)" }}>
        <Radio name="marca" checked={brand === null} onChange={() => setBrand(null)} label="Sistema actual" help="Oro del Taller · Playfair en la marca · JetBrains Mono" />
        <Radio name="marca" checked={brand === "aquila"} onChange={() => setBrand("aquila")} label="Propuesta Aquila" help="Azul de interfaz #1D4ED8 (en oscuro, #6D9BFF) · grafito · IBM Plex Mono" />
        <Radio name="tema" checked={!light} onChange={() => light && toggleLight()} label="Taller oscuro" />
        <Radio name="tema" checked={light} onChange={() => !light && toggleLight()} label="Taller claro" />
      </div>
      <Help style={{ marginTop: "var(--sk-sp-4)" }}>Se guarda solo en este navegador; no cambia nada para el resto del equipo.</Help>
    </Modal>
  );
}
